export enum MarketingPermissionsRoute {
  // default
  HOME = '/sites/:siteId/settings/marketing-permissions',
}
